import React from "react";

import PageHero from "../components/PageHero";
import Hero from "../components/Hero";
import FeaturedProducts from "../components/FeaturedProducts";
import Services from "../components/Services";
import Contact from "../components/Contact";

const HomePage = () => {
	return (
		<main>
			<PageHero />
			<Hero />
			<FeaturedProducts />
			<Services />
			<Contact />
		</main>
	);
};
export default HomePage;
